import { Injectable } from '@angular/core';

import { TipoDeslocamento } from "./deslocamento-tipos.model";

@Injectable()
export class DeslocamentoTiposService {

  constructor() { }

  templateResult(item: TipoDeslocamento) {
    var text: string = item.nome.concat(" (" + item.sigla + ")");
    return text;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamento-tipos/deslocamento-tipos.service.ts
 **/